module.exports = __webpack_public_path__ + "img/17.d4014456.jpg";